// src/components/BakeryLoginForm.jsx
import React, { useState, useContext } from "react";
import { useNavigate } from 'react-router-dom';
import { Form, Button, Card, Container, Alert, InputGroup } from 'react-bootstrap';
import { AppContext } from "../context/appContext";
import { Auth } from "aws-amplify";
import { Eye, EyeSlash } from "react-bootstrap-icons"; // install if not already


function BakeryLoginForm() {
  const {
			setUsername: setLoginUsername,
			setUserType,
			setUserSub,
			setGlobalLoading,
		} = useContext(AppContext);

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();  // For navigation
  const [showPassword, setShowPassword] = useState(false);


  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');  // Clear previous error

    try {
			setGlobalLoading(true);
      const response = await Auth.signIn(username, password);

      // const url = 'https://vffutpswql.execute-api.us-east-1.amazonaws.com/dev/auth';

      // 1) Send login request
      // const response = await axios.post(
      //   url,
      //   {
      //     action: 'login',
      //     username,
      //     password,
      //   },
      //   {
      //     withCredentials: true,
      //   }
      // );

			const { signInUserSession } = response;

      setLoginUsername(username);
			setUserType(
				signInUserSession?.["accessToken"]?.["payload"]?.["cognito:groups"]?.[0] ||
					"admin",
			);
			setUserSub(signInUserSession["accessToken"]["payload"]["sub"]);

      navigate('/');
			setGlobalLoading(false);
    } catch (error) {
      console.error('Login error:', error);
      if (error.response) {
        setError(error.response.data.message);
		setGlobalLoading(false);
      } else {
        setError('An error occurred');
		setGlobalLoading(false);
      }
    }
  };

  return (
			<Container
				className="d-flex align-items-center justify-content-center"
				style={{ minHeight: "100vh" }}>
				<Card
					className="shadow"
					style={{ maxWidth: "400px", width: "100%", borderRadius: "10px" }}>
					<Card.Body>
						<h2 >Cakery Login</h2>
						<div className="text-center mb-4">
							{/* Display image from public folder */}
							<img
								src="/faithwelcomeback.png"
								alt="Welcome"
								style={{ maxWidth: "100%", height: "auto", borderRadius: "8px" }}
							/>
						</div>
						{error && <Alert variant="danger">{error}</Alert>}
						<Form onSubmit={handleLogin}>
							<Form.Group className="mb-3" controlId="username">
								<Form.Label> Email address </Form.Label>
								<Form.Control
									type="text"
									placeholder="Enter your username"
									value={username}
									onChange={(e) => setUsername(e.target.value.toLowerCase())}
									required
								/>
							</Form.Group>

							<Form.Group className="mb-3" controlId="password">
							<Form.Label>Password</Form.Label>
							<InputGroup>
								<Form.Control
								type={showPassword ? "text" : "password"}
								placeholder="Enter your password"
								value={password}
								onChange={(e) => setPassword(e.target.value)}
								required
								/>
								<InputGroup.Text
								onClick={() => setShowPassword(!showPassword)}
								style={{ cursor: "pointer", background: "white", borderLeft: "none" }}
								>
								{showPassword ? <EyeSlash /> : <Eye />}
								</InputGroup.Text>
							</InputGroup>
							</Form.Group>

							<div className="d-grid gap-2">
								<Button variant="primary" type="submit" className="rounded-pill btn-accent">
									Log In
								</Button>
								<div className="mt-2 text-center">
									<div>
										Don't have an account ?{" "}
										<span
											style={{
												color: "#0d6efd",
												cursor: "pointer"
											}}
											onClick={() => navigate("/register-form")}>
											Register
										</span>
									</div>
									<div className="mt-2">
										Forgot your password?{" "}
										<span
											style={{
												color: "#0d6efd",
												cursor: "pointer"
											}}
											onClick={() => navigate("/forgot-password")}>
											Reset it here
										</span>
									</div>
								</div>
							</div>
						</Form>
					</Card.Body>
				</Card>
			</Container>
		);
}

export default BakeryLoginForm;
